import type { Filters } from '@ipfabric/utils';
import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import { createSimpleFilterFieldsFromColumns } from 'components/Table/helpers/createSimpleFilterFieldsFromColumns';
import type { IntentFilters } from 'components/Table/model/TableModel';

export interface InitializeSimpleFiltersCommand {
  initialFilters: Filters;
}

export const initializeSimpleFilters: ApiTableCommandFactory<
  InitializeSimpleFiltersCommand
> = (cmdContext) => async (command) => {
  const {
    endpoint: { columns },
    simpleFilterFields: oldSimpleFilterFields,
  } = cmdContext.getState();
  const simpleFilterFields = createSimpleFilterFieldsFromColumns(
    columns,
    command.initialFilters,
    oldSimpleFilterFields,
  );

  const intentFilters = columns.reduce<IntentFilters>((acc, column) => {
    const filter = (command.initialFilters as any)[column.key];

    if (filter?.[0] === 'color') {
      acc[column.key] = filter[2] ?? null;
    }

    return acc;
  }, {});

  cmdContext.updateState((draft) => {
    draft.simpleFilterFields = simpleFilterFields;
    draft.simpleFilterFieldsSubmitted = simpleFilterFields;
    draft.intentFilters = intentFilters;
  });
};
